import { Container } from "@/components/Container/Container";
import { Section } from "@/components/Section/Section";
import { Reveal } from "@/components/Reveal/Reveal";
import { Button } from "@/components/Button/Button";
import { trackEvent } from "@/lib/analytics";
import { useLenis } from "@/lib/LenisProvider";
import { hero } from "@/spiel/hero";
import styles from "./Hero.module.scss";

export const Hero = () => {
  const { scrollTo } = useLenis();

  return (
    <Section id="hero" className={styles.hero}>
      <Container>
        <div className={styles.content}>
          <Reveal>
            <h1 className={styles.tagline}>{hero.tagLine}</h1>
          </Reveal>

          <Reveal delay={0.15}>
            <p className={styles.support}>{hero.support}</p>
          </Reveal>

          <Reveal delay={0.25}>
            <div className={styles.actions}>
              <Button
                onClick={() => {
                  trackEvent("cta_click", {
                    cta_label: hero.ctaPrimary,
                    link_href: "#contact",
                  });
                  scrollTo("#contact");
                }}
              >
                {hero.ctaPrimary}
              </Button>
              <Button
                variant="ghost"
                onClick={() => {
                  trackEvent("cta_click", {
                    cta_label: hero.ctaSecondary,
                    link_href: "#work",
                  });
                  scrollTo("#work");
                }}
              >
                {hero.ctaSecondary}
              </Button>
            </div>
          </Reveal>
        </div>
      </Container>

      <div className={styles.glow} aria-hidden="true" />
    </Section>
  );
};
